import type { VisualizerSettings } from "@/types"

export const DEFAULT_SETTINGS: VisualizerSettings = {
  font: "Bebas Neue",
  customFontName: null,
  fontSize: 88,
  textColor: "#ffffff",
  accentColor: "#ff2d55",
  textShadow: true,
  textStyle: "fill",
  letterSpacing: 4,
  textGradientColor: "#0a84ff",
  textWrap: true,
  textMaxWidth: 85,
  textVerticalPos: 50,
  hookWordColor: "#ffd60a",
  hookWordStyle: "color",
  bgType: "mesh",
  bgColor1: "#09090f",
  bgColor2: "#1c0b2e",
  bgAccent: "#ff2d55",
  bgVideoDim: 55,
  bgVideoBlur: false,
  bgVideoBlendMode: "normal",
  bgVideoLoop: true,
  vizStyle: "bars",
  vizColor: "#ff2d55",
  vizSecondaryColor: "#0a84ff",
  vizHeight: 30,
  vizOpacity: 80,
  vizMirror: true,
  vizBars: 64,
  animStyle: "pop",
  wordReveal: "fill-in",
  syncMode: "line",
  beatReactive: true,
  snapToBeat: false,
  snapSubdivision: 1,
  showPrev: true,
  showNext: true,
  prevOpacity: 25,
  nextOpacity: 15,
  textOutlineStyle: "single",
  bgGradientPreset: "none",
  audioReactiveBorder: false,
  watermark: {
    enabled: false,
    text: "@username",
    position: "bottom-right",
    opacity: 60,
    fontSize: 24,
    color: "#ffffff",
  },
  aspectRatio: "16:9",
  exportWidth: 1920,
  exportHeight: 1080,
  exportFps: 30,
  exportBitrate: "8000k",
  uiTheme: "system",
}
